import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { IActivityReportDownloadFieldParams } from "./activity-report-download-field.model";

@Component({
  standalone: false,
  selector: 'msv-activity-report-download-field',
  templateUrl: './activity-report-download-field.component.html',
  styleUrls: ['./activity-report-download-field.component.scss']
})
export class ActivityReportDownloadFieldComponent implements ICellRendererAngularComp {
  activityReportId = '';
  params: any;


  // gets called once before the renderer is used
  agInit(params: IActivityReportDownloadFieldParams): void {
    this.params = params;
    this.activityReportId = params.value.toString();
  }

  // gets called whenever the cell refreshes
  refresh(params: IActivityReportDownloadFieldParams): boolean {
    this.activityReportId = params.value.toString();
    return false;
  }

  downloadActivityReport(){
    if (this.params && typeof this.params.onClick === 'function') {
      this.params.onClick(this.activityReportId, this.params.data.InterimSeqId);
    }
  }
}